module.exports = __webpack_public_path__ + "static/media/imgproduct1.ee78c9bd.png";